import { Model } from 'shared/services/api/models/Model'
import { LetterboxDocumentContentV1 } from './letterboxResponses'

export class LetterboxDocumentContent extends Model {
  public readonly type: string
  public readonly size: number
  public readonly hash: string

  constructor(src: LetterboxDocumentContentV1) {
    super(src, { allowEmpty: false })
    this.type = src.type
    this.size = src.size
    this.hash = src.hash
  }
}
